import React, { useCallback, useRef, useEffect, useState } from 'react'
import Dropdown from './Dropdown'
import './dropdown.css'

const FilterOptionsDropdown = ({
  data,
  filter,
  setSelectedFilterOptions,
  setSelectedFilter,
  filters,
  isSearchable,
  selectedFilterOptions,
  hideFilters,
  setHideFilters,
}) => {
  const filterDropdownRef = useRef(null)
  const filterButtonRef = useRef(null)
  const [selectedValues, setSelectedValues] = useState([])
  const [showFiltersDropdown, setShowFilterDropdown] = useState(false)
  const dropdownRef = useRef(null)
  const [dropdownData, setDropdownData] = useState([])
  const [search, setSearch] = useState('')
  const changeHandler = useCallback(
    (value) => {
      const temp = [...selectedValues]
      const selectedValuesLength = temp.length
      const index = temp.indexOf(value)
      if (index === -1) {
        temp.push(value)
      } else {
        temp.splice(index, 1)
      }
      const selectedFilterOptionsTemp = [...selectedFilterOptions]
      if (selectedValuesLength >= 1) {
        if (temp.length === 0) {
          selectedFilterOptionsTemp.splice(
            selectedFilterOptionsTemp.length - 1,
            1
          )
        } else {
          selectedFilterOptionsTemp[selectedFilterOptions.length - 1].value = [
            ...temp,
          ]
        }
      } else {
        selectedFilterOptionsTemp.push({
          filter: filter,
          nature: true,
          value: [value],
        })
      }
      setSelectedValues([...temp])
      setSelectedFilterOptions([...selectedFilterOptionsTemp])
    },
    [filter, setSelectedFilterOptions, selectedFilterOptions, selectedValues]
  )

  useEffect(() => {
    window.addEventListener('click', (event) => {
      if (
        !filterButtonRef?.current?.contains(event?.target) &&
        !dropdownRef?.current?.contains(event?.target) &&
        !filterDropdownRef?.current?.contains(event.target)
      ) {
        setSelectedFilter('')
        setSelectedValues([])
        setShowFilterDropdown(false)
        setSearch('')
      }
    })
    return () => window.removeEventListener('click', () => {})
  }, [dropdownRef, setSelectedFilter, filter, setSelectedValues, setSearch])
  useEffect(() => {
    if (data?.length > 0) {
      if (search.trim() === '') {
        setDropdownData([...data])
      } else {
        setDropdownData([
          ...data.filter((item) =>
            item.label.toUpperCase().includes(search.trim().toUpperCase())
          ),
        ])
      }
    } else {
      setDropdownData([])
    }
  }, [setDropdownData, search, data])
  return (
    <div className='filter'>
      {!hideFilters && (
        <button
          className='tag-filter-button'
          onClick={() => setShowFilterDropdown(true)}
          ref={filterButtonRef}
        >
          <span>+</span>Add filter
        </button>
      )}

      <button
        onClick={() => setHideFilters(!hideFilters)}
        className='remove-filter-button'
      >
        {hideFilters ? 'Show' : 'Hide'} filters
      </button>
      <div
        className={
          showFiltersDropdown && !hideFilters
            ? 'dropdown filter-dropdown active'
            : 'dropdown filter-dropdown'
        }
        ref={dropdownRef}
      >
        {filters?.map((item) => (
          <div
            onClick={() => {
              setSelectedFilter(item.value)
              setShowFilterDropdown(false)
            }}
            key={item.value}
            className={
              selectedValues.indexOf(item.value) !== -1
                ? 'label active'
                : 'label'
            }
          >
            <span>{item.label}</span>
          </div>
        ))}
      </div>
      <div
        className={
          !showFiltersDropdown && filter && !hideFilters
            ? 'dropdown filter-dropdown active'
            : 'dropdown filter-dropdown'
        }
        ref={filterDropdownRef}
      >
        {isSearchable && (
          <div className='search'>
            <input value={search} onChange={(e) => setSearch(e.target.value)} />
          </div>
        )}
        {dropdownData?.map((item) => (
          <div
            onClick={() => {
              changeHandler(item.value)
            }}
            key={item.value}
            className={
              selectedValues.indexOf(item.value) !== -1
                ? 'label active'
                : 'label'
            }
          >
            <div>{selectedValues.indexOf(item.value) !== -1 ? '✔' : ''}</div>
            <span>{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  )
}

export default FilterOptionsDropdown
